export default __webpack_public_path__ + "static/media/castaneda_taco.ca9fea60.jpg";